module.exports = __webpack_public_path__ + "static/img/contactban.451351d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contactban.jpg
// module id = vhBw
// module chunks = 1